import "../pages.scss"
import { PedidosHistorialState } from '../../context/pedidoshistorial/PedidosHistorialState';
import Datatable from "./PedidosHistorialTable/Datatable";

const PedidosHistorialPage = () => {
  return (
    <>
      <PedidosHistorialState>
        <Datatable />
      </PedidosHistorialState>

    </>
  )
}

export default PedidosHistorialPage